<template>
    <v-card color="primary" flat class="business-intro">
        <v-img :src="image" alt="" />
        <div class="business-intro__text">
            <v-card-subtitle class="pt-md-40 pb-md-24">
                <v-img src="/images/business/quotes.svg" max-width="24" alt="" class="mx-auto" />
            </v-card-subtitle>
            <v-card-title v-if="title" class="justify-center pt-0 pb-md-24 white--text line-height-14">
                <div class="client-title font-size-md-36">
                    {{ title }}
                </div>
            </v-card-title>
            <v-card-text class="text-center white--text pb-md-40">
                <p v-html="texts" class="client-title--sm" />
            </v-card-text>
        </div>
    </v-card>
</template>

<script>
export default {
    props: {
        image: String,
        title: String,
        texts: String,
    },
};
</script>

<style lang="scss" scoped>
.business-intro {
    border-radius: 16px;
    &__text {
        background: url(/images/business/intro-logo.svg) no-repeat;
        background-position-x: calc(100% - 20px);
        background-position-y: center;
        background-size: 150px;
    }
}
@media (min-width: 768px) {
    .business-intro {
        &__text {
            background-position-x: calc(100% - 72px);
            background-size: 273px;
        }
    }
}
</style>